<template>
  <div class="link-selector">
    <v-select
      class="select-primary"
      style="width: 100%"
      :options="links"
      label="title"
      :reduce="(option) => option.id"
      v-model="id"
      @input="onChange"
      placeholder="링크선택"
    />
  </div>
</template>
<script>
import Endpoints from "@/common/Endpoints";
import _ from "lodash";

export default {
  components: {},
  name: "LinkSelect",
  async created() {
    await this.getData();
  },
  data() {
    return {
      links: [],
      id: null,
    };
  },
  props: {
    linkModel: {
      type: String,
      required: true,
    },
  },
  watch: {},
  methods: {
    async getData() {
      const res = await this.$axios.get("/common/deeplinks");
      this.links = [{ id: null, title: "없음" }, ...res.data.data];
    },
    onChange() {
      const link = _.find(this.links, { id: this.id });
      let value = "";
      if (link) {
        value = `${Endpoints.blipSchema}${link.link}`;
      }
      if (link.required) {
        const params = link.required.split(",");
        value = `${value}?${params.map((p) => `${p}=?`).join("&")}`;
      }
      this.$emit("linkChangeEvent", { value, linkModel: this.linkModel });
    },
  },
};
</script>
